<template>
    <div style="width:100%;heigh:100%;">
        <el-table :data="payload" stripe style="width: 100%">
            <el-table-column prop="DevID" label="设备"  ></el-table-column>
            <el-table-column prop="TagName" label="数据项"  ></el-table-column>
            <el-table-column prop="TagValue" label="值" width="160">
                <template slot-scope="scope">
                    <el-input size="small" style="width:100px;color: #000000" maxlength="16" v-model="payload[scope.$index].TagValue" :readonly="true"></el-input>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
export default {
    name: 'dataCollection',
	data () {
        return {
            searchForm:{
                deviceId:'',
                dtuId:'',
            },
            tableData:[],
            tableCurrentPage:1,
            payload:[],
            tableTotalPage:100,
            timer:null,
            timerFlag:false
        }
    },
    mounted:function(){
        clearInterval(this.timer);
        this.initTable();
    },
    methods:{
        setTimer: function () {
            this.timer = setInterval( () => {
                console.log("定时器");
                this.timerFlag = true;
                this.search();
            }, 5000)
　　    },
        search:function(){
            this.$RequestUtil.get({
				url: '/api/dataCollection/realtimeData',
				params: {
                    deviceId:this.searchForm.deviceId,
                    dtuId:this.searchForm.dtuId
                },
                success: (res) => {
                    if(!this.timerFlag){
                        this.setTimer();
                        console.log("开启定时器");
                    }
                    if(res.msg == "success"){
                        this.tableData = res.data;
                        if(this.tableData != null && this.tableData.length > 0){
                            this.payload = JSON.parse(res.data[0].payload);
                            for(var i = 0;i<this.payload.length;i++){
                                if(this.payload[i].TagType == "Bool" ){
                                    if(this.payload[i].TagValue == false){
                                        this.payload[i].TagValue = "false";
                                    }else{
                                        this.payload[i].TagValue = "true";
                                    }
                                }
                            }
                        }
                    }
                }
            });
        },
        pageChange:function(targetPage){
            this.tableCurrentPage = targetPage;
            this.search();
        },
        initTable:function(){
            this.search();
        },
        parseTime:function(val){
            return new Date(val.time).toLocaleString();
        }
    },
    deactivated: function(){
        //清空定时器
        console.log("deactivated");
		clearInterval(this.timer)
	},
    destroyed: function () {
        console.log("destroyed");
        clearInterval(this.timer)
    }
}
</script>

<style scoped>
.el-row {
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
}
.bg-purple {
    background: #d3dce6;
}

.table_searchbar{
    width:100%;
    height:100px;
    margin-top: 10px;
    margin-bottom: 20px;
}
.el-upload--picture-card{
    width:40px;
    height:40px;
}
.el-input.is-disabled .el-input__inner{
    color:#000;
}
</style>



// WEBPACK FOOTER //
// src/views/Realtime.vue